import { UserPlus, ClipboardEdit, FileCheck } from "lucide-react";
const pasos = [{
  num: "01",
  icon: UserPlus,
  title: "Regístrate gratis",
  desc: "Crea tu cuenta en menos de 2 minutos. Configura los datos de tu empresa y empieza a usar la plataforma sin costo."
}, {
  num: "02",
  icon: ClipboardEdit,
  title: "Registra a tus clientes",
  desc: "Usa el flujo KYC guiado para capturar datos, subir documentos y verificar identidad. En el plan Pro, el OCR extrae los datos automáticamente de la INE."
}, {
  num: "03",
  icon: FileCheck,
  title: "Genera tu expediente",
  desc: "Con un clic, genera la ficha de identificación completa en PDF, con todos los anexos y el resultado del screening. Lista para auditoría."
}];
export default function ComoFunciona() {
  return <section data-section-id="REEMPLAZAR" id="como-funciona" className="bg-[#020617] text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center text-center">
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            De cero a cumplimiento <span className="text-primary font-mono">en 3 pasos</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {pasos.map((paso, i) => {
          const Icon = paso.icon;
          return <div key={paso.num} data-index={i} className="relative p-6 md:p-8 rounded-lg bg-card border border-border hover:border-primary/50 transition-all duration-200">
                <span className="font-mono text-xs text-primary uppercase tracking-widest">
                  Paso {paso.num}
                </span>
                <div className="mt-4 size-12 rounded-md bg-primary/10 flex items-center justify-center mb-5">
                  <Icon className="size-6 text-primary" strokeWidth={1.5} />
                </div>
                <h3 className="font-default text-xl font-bold text-white mb-3">{paso.title}</h3>
                <p className="font-default text-sm text-slate-400 leading-relaxed">{paso.desc}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}